/** Angular core dependencies */
import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";
import { FullComponent } from "./shared/layouts/full/full.component";
import { LandingPageComponent } from "./landing-page/landing-page.component";
import { AssignedAccountantComponent } from "./assigned-accountant/assigned-accountant.component";
import { InquiryPageComponent } from "./static-pages/inquiry-page/inquiry-page.component";
import { AboutUsComponent } from "./static-pages/about-us/about-us.component";
import { TermsConditionComponent } from "./static-pages/terms-condition/terms-condition.component";
import { AuthGuard } from '@shared/guards/auth.guard';
import { CanLogoutClientGuard } from "@shared/guards/can-logout-client.guard";
import { VenaqiServicesComponent } from "./static-pages/venaqi-services/venaqi-services.component";
import { VenaqiServiceTwoComponent } from "./static-pages/venaqi-service-two/venaqi-service-two.component";
import { MentionsLegalesComponent } from "./static-pages/mentions-legales/mentions-legales.component";
import { PrivacyPolicyComponent } from "./static-pages/privacy-policy/privacy-policy.component";


const routes: Routes = [
  {
    path: "",
    component: FullComponent,
    canActivate: [AuthGuard],
    children: [
      {
        path: "assign-accountants",
        component: AssignedAccountantComponent,
        canDeactivate: [CanLogoutClientGuard]
      },
      {
        path: "superadmin",
        loadChildren:
          "./features-modules/superadmin/superadmin.module#SuperadminModule",
      },
      {
        path: "chiefaccountant",
        loadChildren:
        "./features-modules/chief-accountant/chief-accountant.module#ChiefAccountantModule",
      },
      {
        path: "accountant",
        loadChildren:
        "./features-modules/accountant/accountant.module#AccountantModule",
      },
      {
        path: "client",
        loadChildren:
        "./features-modules/client/client.module#ClientModule",
      }
    ],
  },

  // Static pages routing
  {
    path: "landing-page",
    component: LandingPageComponent,
  },
  {
    path: "landing-page/:userId/:titleId/:unsubscribeSurvey/:isCustNeed",
    component: LandingPageComponent,
  },
  {
    path: "landing-page/:userId/:unsubscribeSurvey/:isCustNeed",
    component: LandingPageComponent,
  },
  {
    path: "inquiry-form",
    component: InquiryPageComponent,
  },
  {
    path: "about-us",
    component: AboutUsComponent,
  },
  {
    path: "terms-condition",
    component: TermsConditionComponent,
  },
  {
    path: "venaqi-service",
    component: VenaqiServicesComponent,
  },
  {
    path: "venaqi-service-two",
    component: VenaqiServiceTwoComponent,
  },
  {
    path: "mentions-legales",
    component: MentionsLegalesComponent,
  },
  {
    path: "privacy-policy",
    component: PrivacyPolicyComponent,
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { relativeLinkResolution: 'legacy' })],
  exports: [RouterModule],
})
export class AppRoutingModule {}
